
import {finalize} from 'rxjs/operators';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { noSpinnerFalseValue } from './../spinner/spinner.service';

import { noSpinnerHeader, SpinnerService } from '../spinner/spinner.service';

@Injectable()
export class SpinnerInterceptorService implements HttpInterceptor {
    constructor(private spinnerService: SpinnerService) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        if (!request.headers.has(noSpinnerHeader) || request.headers[noSpinnerHeader] === noSpinnerFalseValue) {
            this.spinnerService.start();

            return next.handle(request).pipe(finalize(() => {
                this.spinnerService.stop();
            }));
        } else {
            return next.handle(request);
        }
    }
}
